import * as ReactDOM from "react-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import { Root } from "./component/root/Root";
import registerServiceWorker from "./registerServiceWorker";
import "./resources/AntStyles/AntDesign/antd.cleanui.css";
import "./resources/CleanStyles/Core/core.cleanui.css";
import "./index.css";

// render app
ReactDOM.render(
  <Router history={createBrowserHistory()}>
    <Root />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();
